import { render, staticRenderFns } from "./DisplayCommunicationLine.vue?vue&type=template&id=1350d3c7&scoped=true"
import script from "./DisplayCommunicationLine.vue?vue&type=script&lang=js"
export * from "./DisplayCommunicationLine.vue?vue&type=script&lang=js"
import style0 from "./DisplayCommunicationLine.vue?vue&type=style&index=0&id=1350d3c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1350d3c7",
  null
  
)

export default component.exports